import { DEEPLINKS } from '../constants/deeplinks';
import { Logger } from './Logger';

export const goToPortal = ({
  navigation,
  url,
  shouldRedirect,
  shouldGoBack
} = {}) => {
  Logger.log('GoToPortal called');

  if (url) {
    Logger.log('URL: ', url);
    if (shouldGoBack) {
      Logger.log('Will goBack');
      navigation?.goBack?.(url);
    } else {
      shouldRedirect ? navigation?.redirect(url) : navigation?.push(url);
    }
    return;
  }

  const { postLoginRedirect: redirectTo, shouldReplace } = getUrlSearchParams({
    navigation
  });
  if (redirectTo) {
    Logger.log('URL: ', redirectTo);

    // Highest priority, caused on error flows on WEB_NATIVE or APP_NATIVE flows
    if (shouldGoBack) {
      Logger.log('[shouldGoBack] Will goBack');
      navigation?.goBack();
    }
    // Second highest, WEB_PORTAL flow
    else if (shouldRedirect) {
      Logger.log('[shouldRedirect] Will redirect');
      navigation?.redirect(redirectTo);
    }
    // Used when successful flow is called on WEB_NATIVE or APP_NATIVE flows
    else if (shouldReplace) {
      Logger.log('[shouldReplace] Will replace');
      navigation?.replace(redirectTo);
    }
    // Default behavior
    else {
      Logger.log('[Default behavior] Will goBack');
      navigation?.goBack();
    }
    return;
  }

  Logger.log('URL: ', DEEPLINKS.PORTAL.HOME);
  if (shouldGoBack) {
    Logger.log('[No postLoginRedirectRoute] Will goBack');
    navigation?.goBack();
  } else {
    Logger.log('[No postLoginRedirectRoute] Will redirect or push');
    shouldRedirect
      ? navigation?.redirect(DEEPLINKS.PORTAL.HOME)
      : navigation?.push(DEEPLINKS.PORTAL.HOME);
  }
};

export const getUrlSearchParams = ({ navigation } = {}) => {
  const urlSearchParams = new URLSearchParams(navigation?.location?.search);
  return Object.fromEntries(urlSearchParams.entries());
};

export const getJshellCompatibleUrl = ({ url } = {}) =>
  url?.includes('/ucde/') ? url.replace('/ucde', '') : url;

export const urlShouldRedirectToMyPrintersPage = ({ url } = {}) => {
  if (!url) return false;

  const [country, language] = url.split('/').slice(1, 3) || [];

  if (country?.length !== 2 || language?.length !== 2) return false;

  const locale = `/${country}/${language}`.toLowerCase();

  return [
    DEEPLINKS.LEGACY_PORTAL.ACTIVATE_HP_PLUS,
    DEEPLINKS.LEGACY_PORTAL.MOBILE_FAX,
    DEEPLINKS.LEGACY_PORTAL.PAPER_SUBSCRIPTION
  ].some((link) => `${locale}${link}` === url);
};
